var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecoverPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.5,
    height: 63.25,
    viewBox: "0 0 126.5 63.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password_3_",
    "data-name": "password (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M239.939,42.167a5.269,5.269,0,0,1-5.271-5.271V5.271a5.27,5.27,0,0,1,10.541,0V36.9A5.269,5.269,0,0,1,239.939,42.167Zm0,0",
    transform: "translate(-176.689 0)",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M184.519,58.344a5.271,5.271,0,0,1-2.641-9.835L209.261,32.7a5.272,5.272,0,1,1,5.275,9.129L187.155,57.637a5.264,5.264,0,0,1-2.636.706Zm0,0",
    transform: "translate(-134.958 -24.083)",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M211.9,58.344a5.228,5.228,0,0,1-2.63-.706L181.884,41.825a5.269,5.269,0,1,1,5.266-9.129l27.382,15.812a5.271,5.271,0,0,1-2.636,9.836Zm0,0",
    transform: "translate(-134.958 -24.083)",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M35.294,24.425l-5.787-3.342,5.787-3.341a5.271,5.271,0,1,0-5.27-9.129l-5.788,3.341V5.271a5.27,5.27,0,0,0-10.541,0v6.683L7.907,8.613a5.271,5.271,0,0,0-5.27,9.129l5.787,3.341L2.637,24.425a5.271,5.271,0,1,0,5.27,9.129l5.788-3.342V36.9a5.27,5.27,0,1,0,10.541,0V30.212l5.788,3.342a5.271,5.271,0,0,0,5.27-9.129Zm0,0",
    transform: "translate(-0.001 0)",
    fill: "#42a5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M393.767,24.425l-5.787-3.342,5.787-3.341A5.271,5.271,0,0,0,388.5,8.613l-5.787,3.341V5.271a5.271,5.271,0,0,0-10.542,0v6.683L366.38,8.613a5.271,5.271,0,0,0-5.27,9.129l5.788,3.341-5.788,3.342a5.271,5.271,0,1,0,5.27,9.129l5.788-3.342V36.9a5.271,5.271,0,1,0,10.542,0V30.212l5.787,3.342a5.271,5.271,0,0,0,5.271-9.129Zm0,0",
    transform: "translate(-269.903 0)",
    fill: "#42a5f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M31.625,223.874H5.27a5.271,5.271,0,0,1,0-10.542H31.625a5.271,5.271,0,0,1,0,10.542Zm0,0",
    transform: "translate(0 -160.624)",
    fill: "#607d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M212.957,223.874H186.6a5.271,5.271,0,1,1,0-10.542h26.353a5.271,5.271,0,1,1,0,10.542Zm0,0",
    transform: "translate(-136.53 -160.624)",
    fill: "#607d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M394.293,223.874H367.938a5.271,5.271,0,0,1,0-10.542h26.354a5.271,5.271,0,0,1,0,10.542Zm0,0",
    transform: "translate(-273.064 -160.624)",
    fill: "#607d8b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverPassword);
export default __webpack_public_path__ + "static/media/recover-password.103a18ea357ab9ccda87e52885776489.svg";
export { ForwardRef as ReactComponent };